// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Toolbar More Actions Component */
:host {
  display: inline-flex;
}

:host(:not([no-padding])), .more:not([no-padding]) {
  margin-inline-start: 2px;
}

::slotted(ids-separator) {
  align-self: center;
  justify-self: center;
}

.ids-toolbar-more-actions {
  padding-inline-end: 1px;
  white-space: nowrap;
  width: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-toolbar/ids-toolbar-more-actions.scss"],"names":[],"mappings":"AAAA,uCAAA;AAEA;EACE,oBAAA;AAAF;;AAGA;EACE,wBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,oBAAA;AAAF;;AAGA;EACE,uBAAA;EACA,mBAAA;EACA,WAAA;AAAF","sourcesContent":["/* Ids Toolbar More Actions Component */\n\n:host {\n  display: inline-flex;\n}\n\n:host(:not([no-padding])), .more:not([no-padding]) {\n  margin-inline-start: 2px;\n}\n\n::slotted(ids-separator) {\n  align-self: center;\n  justify-self: center;\n}\n\n.ids-toolbar-more-actions {\n  padding-inline-end: 1px;\n  white-space: nowrap;\n  width: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
